import { sendEmailCarrier } from "../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useSendEmail = () => {
  return useMutation(sendEmailCarrier);
};
export default useSendEmail;
